/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'dns-config';

export const dnsConfigModalBreadcrumbTitle = `${prefix}.dnsConfigModalBreadcrumbTitle`;

export const ENGLISH = {
    [dnsConfigModalBreadcrumbTitle]: 'Subdomain',
};
